import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@mui/material/Dialog';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, updateData, updateRouteNumber } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save'; // Import the Save icon
import EditNoteIcon from '@mui/icons-material/EditNote';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import Stack from '@mui/material/Stack';
import HistoryIcon from '@mui/icons-material/History';
//import { makeStyles } from '@mui/styles';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import CancelIcon from '@mui/icons-material/Cancel';
import Select from 'react-select';
import { FixedSizeList as List } from 'react-window';
import * as XLSX from "xlsx";
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';

function CustomerIndex() {

  //const classes = useStyles();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [Alldata, setAllData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [editedRouteSequenceNo, setEditedRouteSequenceNo] = useState(null);
  const [editItemId, setEditItemId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Change this number according to your preference
  const [loading, setLoading] = useState(false);

  // const { isAuthenticated, companyId, userId, logout, token } = useAuth();
  const [formData, setFormData] = useState();
  const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
  const hasCreateMasterPermission = permissions.includes('Create Master');
  const hasEditMasterPermission = permissions.includes('Edit Master');
  const hasDeleteMasterPermission = permissions.includes('Delete Master');

  // Define useStyles hook



  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }
    //fetchtableData();
    fetchRouteTypes();
        // Refresh the data after deletion
        handleRouteWiseCustomerChange(selectedRoute);
        fetchAllCustomer();
  }, [isAuthenticated, companyId, token, logout]);




  const fetchAllCustomer = async () => {
    setLoading(true); // Set loading state to true when fetching starts
    try {
      const response = await fetchData('CustomerApi', `/${companyId}`, token);

      if (response.responseCode === '1111') {
        setAllData(response.response_data);
      } else {
        console.error('Unexpected response code:');

      }
    } catch (error) {
      console.error('Error fetching customers:', error);

    } finally {
      setLoading(false);
    }
  };


  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);

  const fetchRouteTypes = async () => {
    try {
      const response = await fetchData('RouteApi', `/${companyId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(route => ({
          value: route.id,
          label: route.name
        }));
        setRouteOptions(options);

      }
    } catch (error) {
      console.error('Error fetching route:', error);
    }
  };

  const handleRouteWiseCustomerChange = async (selectedOption) => {
    setSelectedRoute(selectedOption);
    setLoading(true);
    try {
      const response = await fetchData('CustomerApi', `/${companyId}/${selectedOption.value}`, token);
      if (response.responseCode === '1111') {
        setData(response.response_data);
        setFormData(response.response_data);
      }

    } catch (error) {
      console.error('Error fetching items:', error);
    } finally {
      setLoading(false);
    }
  };



  const handleDelete = async () => {
    deleteData('CustomerApi', `${deleteItemId}`, token)
      .then((response) => {
        console.log('Record deleted successfully:', response.data);
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
        // Refresh the data after deletion
        handleRouteWiseCustomerChange(selectedRoute);
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });
  };

  const handleActivate = (itemId) => {
    activateData('CustomerApi', `${itemId}`, token)
      .then((response) => {
        // fetchtableData();
      })
      .catch((error) => {
        // Handle errors for the activation request
      });
  };

  const openConfirmDialog = (itemId) => {
    setDeleteItemId(itemId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteItemId(null);
    setConfirmDialogOpen(false);
  };


  const handleEdit = (itemId, currentRouteSequenceNo) => {
    setEditItemId(itemId);
    setEditedRouteSequenceNo(currentRouteSequenceNo);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);

    const updatedData = {
      ID: editItemId, // Use editItemId here
      RouteSequenceNo: editedRouteSequenceNo,
      UpdatedBy: userId,
    };

    updateData('CustomerApi', `${editItemId}`, updatedData, token)
      .then((response) => {
        console.log('Record updated successfully:', response.data);
        setIsLoading(false);
        // Reload the page after updating
        window.location.reload();

      })
      .catch((error) => {
        console.error('Error updating record:', error);
        setIsLoading(false);
      });
  };

  const handleRouteSequenceNoChange = (event) => {
    setEditedRouteSequenceNo(event.target.value);
  };
  // Excel 


  const handleExportExcel = () => {
    // Define headers based on the table structure
    const headers = [
      "Route Order",
      "RouteName",
      "Customer",
      "Contact Name",
      "Contact No1",
      "Contact No2",
      "Email",
      "GST No",
      "AddressLine1",
      "AddressLine2",
      "Pincode",
      "LandMark",
      "Town",
      "District",
      "State",
      "Country",
      "Payment Type",
      "Customer Type",
      "Opening Time",
      "LunchBreak Time",
      "Rating",
      "Remark",
    ];

    // Map data to rows
    const rows = filteredDataItem.map((item) => [
      item.routeSequenceNo,
      item.route,
      item.gst ? `${item.name} (GST)` : item.name, // Add "(GST)" to the name if gst is true
      item.contactPerson,
      item.contactNumber1,  
      item.contactNumber2,
      item.email,
      item.gstNumber,
      item.addressLine1,
      item.addressLine2,
      item.pincode,
      item.landmark,
      item.town,
      item.district,
      item.state,
      item.country,
      item.paymentType,
      item.customerType,
      item.openingTime,
      item.lunchBreak,
      item.customerReview,
      item.remarks
  
    ]);


    // Combine headers and rows into a single sheet
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Data");

    // Export the workbook
    XLSX.writeFile(workbook, "CustomerData.xlsx");
  };


  //search
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchInput, setShowSearchInput] = useState(false);
  //const [showSearchInput, setShowSearchInput] = useState(false);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const toggleSearchInput = () => {
    setShowSearchInput(!showSearchInput);
  };

  const filteredAllDataItem = Alldata.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const filteredDataItem = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

  // Define initial column order
  const [columnOrder, setColumnOrder] = useState([

    'SL No',
    'Sales Executive',
    'Expense Date ',
    'Expense Type',
    'Expense Remark',
    'Odometer',
    'Amount',
    ''

  ]);
  // Process and paginate the data
  const processedData = filteredDataItem.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );


  // Handle page change
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  // Function to handle drag start
  const handleDragStart = (e, index) => {
    e.dataTransfer.setData('columnIndex', index);
  };

  // Function to handle drag over
  const handleDragOver = (e) => {
    e.preventDefault(); // Allow drop
  };
  // Function to handle drop
  const handleDrop = (e, index) => {
    const draggedIndex = e.dataTransfer.getData('columnIndex');
    if (draggedIndex !== index) {
      const newOrder = [...columnOrder];
      // Swap columns
      [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
      setColumnOrder(newOrder);
    }
  };

  // Function to handle refresh
  const handleRefresh = () => {
    window.location.reload();
        // Refresh the data after deletion
        handleRouteWiseCustomerChange(selectedRoute);
  };
  // Calculate total pages
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Logic to slice data for current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);


  // customer order summary
  const [showModal, setShowModal] = useState(false);
  const [sfilteredData, setSFilteredData] = useState([]);


  const closeModal = () => {
    console.log('Closing modal');
    setShowModal(false);
  };


  const [previousData, setPreviousData] = useState([]);
  const [isperviousModalOpen, setIsperivousModalOpen] = useState(false);

  const openpreviousdataModal = () => setIsperivousModalOpen(true);
  const closeperviousModal = () => setIsperivousModalOpen(false);

  const handlePreviousDataClick = async (companyId, id) => {
    try {
      const response = await fetchData('OrderSummaryApi', `/${companyId}/${id}`, token);
      if (response.responseCode === '1111') {
        setPreviousData(response.response_data);
      } else {
        setPreviousData([]); // Clear previous data if the response is not successful
      }
    } catch (error) {
      console.error('Error occurred while fetching Warranty data:', error);
      setPreviousData([]); // Clear previous data if an error occurs
    } finally {
      openpreviousdataModal(); // Ensure the modal opens regardless of data fetch status
    }
  };

  const Row = useCallback(({ index, style }) => {
    const item = filteredAllDataItem[index];
    return (

      <TableRow key={item.id} style={style}>

        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', textAlign: 'center', fontSize: '13px' }}>
          {index + 1}
        </TableCell>
        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', padding: '5px 5px 5px 50px', textAlign: 'left', fontSize: '13px', width: '10%' }}>
          {item.routename}
        </TableCell>
        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', padding: '5px 5px 5px 70px', textAlign: 'left', fontSize: '13px', width: '20%' }}>
          {item.name}  {item.customerCode} {item.gst ? "(GST)" : ""}
        </TableCell>
        {/* <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', padding: '5px 5px 5px 70px', textAlign: 'left', fontSize: '13px', width: '20%' }}>
          {item.gstNumber}
        </TableCell> */}
        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', padding: '10px 10px 10px 120px', textAlign: 'left', fontSize: '13px', width: '15%' }}>
          {item.contactPerson}
        </TableCell>

        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', padding: '17px 17px 17px 120px', textAlign: 'left', fontSize: '13px', width: '10%' }}>
          {item.contactNumber1}, {item.contactNumber2}
        </TableCell>
        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', padding: '10px 10px 10px 80px', textAlign: 'left', fontSize: '13px', width: '20%' }}>
          {item.addressLine1}
        </TableCell>
        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', padding: '6px 6px 6px 60px', textAlign: 'right', fontSize: '13px', width: '10%', color: 'darkred', fontWeight: 'bolder' }}>
          {item.customerType}
        </TableCell>
        <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', padding: '15px 15px 15px 150px', textAlign: 'right', fontSize: '13px', width: '10%' }}>
          {item.paymentType}
        </TableCell>
        {/* <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', padding: '15px 15px 15px 150px', textAlign: 'right', fontSize: '13px', width: '10%' }}>
          {item.remarks}
        </TableCell> */}


      </TableRow>

    );
  }, [filteredAllDataItem]);

  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="w-full  mx-auto" style={{ width: '97%', marginTop: '20px' }}>
      <div className='w-full mb-2 flex justify-between items-center'>



        {/* Left Section: Search and Refresh */}
        <div className='flex items-center'>
          <h6 className='productHead linkcolor mr-4'
            style={{
              fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
              color: 'black', fontWeight: 'bolder'
            }}>
            CUSTOMER
          </h6>
          {loading && (
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999,

            }}>
              <div>
                <CircularProgress style={{ color: 'white' }} />
                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
              </div>
            </div>
          )}
          <input
            className="shadow text-gray-700 leading-tight"
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearch}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            style={{
              width: isFocused ? '300px' : '200px',
              height: '40px',
              border: '1px solid #ccc',
              borderRadius: '15px',
              padding: '0 20px',
              transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
              outline: 'none',
              borderColor: isFocused ? 'darkcyan' : '#ccc',
              boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
            }}
          />

          <Tooltip title="Page Refresh">
            <Button
              onClick={() => window.location.reload()}
              style={{
                background: 'linear-gradient(to right, #C96868, #C96868)',
                borderRadius: '50px',
                padding: '10px 20px',
                color: 'white',
                fontWeight: 'bolder',
                textTransform: 'none',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                maxHeight: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '10px'
              }}
            >
              Refresh
            </Button>
          </Tooltip>
        </div>

        {/* Right Section: Route Selection and Create Button */}
        <div className='flex items-center'>
          <div className="flex flex-col mr-4" style={{ width: '300px', marginLeft: '350px', fontSize: '16px' }}>
            <Select
              value={selectedRoute}
              onChange={handleRouteWiseCustomerChange}
              options={routeOptions}
              placeholder="Select Route"
              isSearchable
              className="mr-4"
              style={{ width: '300px', fontSize: '16px' }}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 1301, // Ensure dropdown appears above the sticky header
                }),
              }}
            />
          </div>
          {hasCreateMasterPermission && (
          <Tooltip title="Create New Customer">
            <Link to="/CustomerCreate" className="inline-block">
              <Button color="primary"
                style={{
                  backgroundColor: 'darkcyan',
                  borderRadius: '50px',
                  padding: '10px 20px',
                  color: 'white',
                  fontWeight: 'bolder',
                  textTransform: 'none',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                  maxHeight: '35px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <AddIcon style={{ fontWeight: 'bolder' }} /> Create
              </Button>
            </Link>
          </Tooltip>
)}
          <Button onClick={handleExportExcel}
            style={{
              background: 'linear-gradient(to right,rgb(104, 201, 152),rgb(7, 55, 21))',
              borderRadius: '50px',
              padding: '10px 20px',
              color: 'white',
              fontWeight: 'bolder',
              textTransform: 'none',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
              maxHeight: '35px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '10px'
            }}
            disabled={isLoading}>
            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Excel"}
          </Button>
        </div>
      </div>


      {selectedRoute && (
        <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', maxWidth: '100%' }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{
                backgroundColor: 'teal',
                position: 'sticky',
                top: 0,
                zIndex: 1, width: '2500px'

              }}>
                <TableRow>
                {/* RouteOrder */}
                  <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke', width: '7%' }}>Order No</TableCell>
                  <TableCell></TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke', width: '20%' }}>Customer</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke' }}>GSTNo</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke' }}>Contact Name</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke' }}>Contact.No</TableCell>
                  {/* <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Location</TableCell> */}
                  <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke' }}>CustomerType</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke' }}>Payment</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke', width: '10%' }}>Remarks</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '14px', padding: '4px', color: 'whitesmoke', width: '10%' }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ backgroundColor: 'white' }}>
                {filteredDataItem.map((item, index) => (
                  <TableRow key={item.id} className="size">
                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '14px', textAlign: 'center', padding: '4px' }}>
                      {editItemId === item.id ? (
                        <input
                          type="text"
                          value={editedRouteSequenceNo}
                          onChange={handleRouteSequenceNoChange}
                        />
                      ) : (
                        item.routeSequenceNo
                      )}
                    </TableCell>
                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '10px', fontWeight: 'bold', padding: '4px' }}>
                      {editItemId === item.id ? (
                        <>
                          <Tooltip title="Save Customer Route Number">
                            <IconButton onClick={(event) => handleSubmit(event, item.id)}>
                              <SaveIcon style={{ color: 'green', height: '19px' }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Refresh">
                            <IconButton onClick={handleRefresh}>
                              <RefreshIcon style={{ color: 'blue', height: '19px' }} />
                            </IconButton>
                          </Tooltip>
                        </>
                      ) : (
                        <Tooltip title="Edit Customer Route Number">
                          <IconButton onClick={() => handleEdit(item.id, item.routeSequenceNo)}>
                            <EditNoteIcon style={{ color: 'darkgoldenrod' }} disabled={isLoading} />
                            {isLoading && <CircularProgress size={24} />}
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '13px', padding: '5px' }}>
                      {item.name} {item.addressLine1} {item.customerCode} {item.gst ? "(GST)" : ""}
                    </TableCell>

                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontSize: '13px', padding: '5px' }}>{item.gstNumber}</TableCell>
                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '13px', padding: '5px' }}>{item.contactPerson}</TableCell>
                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '13px', padding: '5px' }}>{item.contactNumber1}, {item.contactNumber2}</TableCell>
                    {/* <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '14px', padding: '5px' }}>{item.addressLine1}</TableCell> */}
                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '13px', padding: '5px' }}>{item.customerType}</TableCell>
                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '13px', padding: '5px' }}>{item.paymentType}</TableCell>
                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '13px', padding: '5px' }}>{item.remarks}</TableCell>
                    <TableCell sx={{ borderBottom: '1px solid #FFE1E2', fontSize: '13px', padding: '5px' }}>
                      {hasEditMasterPermission && (
                        <Link to={`/CustomerEdit/${item.id}`}>
                          <IconButton>
                            <EditIcon style={{ color: 'blueviolet', fontSize: '25px' }} />
                          </IconButton>
                        </Link>
                      )}

                      {hasDeleteMasterPermission && (
                        <IconButton onClick={() => (item.isActive ? openConfirmDialog(item.id) : handleActivate(item.id))}>
                          {item.isActive ? <DeleteIcon style={{ color: 'brown', height: '20px' }} /> : <ActivateIcon />}
                        </IconButton>
                      )}

                      <IconButton
                        onClick={() => handlePreviousDataClick(companyId, item.id)}
                        style={{ fontWeight: 'bolder', }}
                      >
                        <HistoryIcon style={{ color: 'darkblue', height: '20px' }} />

                      </IconButton>
                    </TableCell>
                  </TableRow>

                ))}
              </TableBody>

              <Dialog
                open={confirmDialogOpen}
                onClose={closeConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to delete this record?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <button
                    onClick={closeConfirmDialog}
                    style={{
                      backgroundColor: '#dc3545',
                      color: '#ffffff',
                      border: '1px solid #dc3545',
                      borderRadius: '4px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      marginRight: '8px',
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    style={{
                      backgroundColor: '#28a745',
                      color: '#ffffff',
                      border: '1px solid #28a745',
                      borderRadius: '4px',
                      padding: '8px 16px',
                      cursor: 'pointer',
                    }}
                  >
                    Confirm
                  </button>
                </DialogActions>
              </Dialog>
            </Table>
          </TableContainer>

        </div >
      )}

      {!selectedRoute && (
        <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '10px' }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ backgroundColor: '#0B5345' }}>
                <TableRow>
                  <TableCell sx={{ fontSize: '15px', padding: '5px', textAlign: 'left', color: 'white' }}>
                    <span style={{ marginLeft: '-5px' }}>Sl.No</span>
                    <span style={{ marginLeft: '45px' }}>Route</span>
                    <span style={{ marginLeft: '150px', color: 'white' }}>Name</span>
                    <span style={{ marginLeft: '230px', color: 'white' }}>Contact Name</span>
                    <span style={{ marginLeft: '100px', color: 'white' }}>Contact.No</span>
                    <span style={{ marginLeft: '130px', color: 'white' }}>Location</span>
                    <span style={{ marginLeft: '170px', color: 'white' }}>CustomerType</span>
                    <span style={{ marginLeft: '120px', color: 'white' }}>Payment</span>
                 
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: 'white' }}>
                <List
                  height={500}
                  itemCount={filteredAllDataItem.length}
                  itemSize={60}
                  width="100%"
                >
                  {Row}
                </List>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}

      <Modal open={isperviousModalOpen} onClose={closeperviousModal} className={isperviousModalOpen ? 'notification-modal' : ''}>
        <div className="fixed inset-0 flex items-center justify-center z-10">
          <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1100px', marginTop: '-300px' }}>
            <h5 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'brown' }}>Previous Order List</h5>

            <div className='w-full mb-2 flex justify-end'>
              <Tooltip title="Close">
                <button className="close-button" onClick={closeperviousModal} style={{ marginLeft: '8px', marginTop: '-50px' }}><CancelIcon /></button>
              </Tooltip>
            </div>
            <br></br>

            <br></br>
            {previousData && previousData.length > 0 ? (
              <TableContainer component={Paper} style={{ marginTop: '-50px' }}>
                <Table>
                  <TableHead sx={{ backgroundColor: '#58A566' }}>
                    <TableRow>
                      <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', width: '50px', textAlign: 'center' }}>Invoice Date</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Item Name</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total Quantity</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Net Amount</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total CGST Amount</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total SGST Amount</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total Discount Amount</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: '#9BC1B3' }}>
                    {previousData.reduce((acc, item, index, array) => {
                      const currentDayTotal = array
                        .filter(data => data.InvoiceDate === item.InvoiceDate)
                        .reduce((sum, data) => sum + data.TotalAmount, 0);

                      acc.push(
                        <TableRow key={item.id}>
                          <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', width: '50px', textAlign: 'center' }}>
                            {item.InvoiceDate && new Date(item.InvoiceDate).toLocaleDateString('en-GB')}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'left' }}>
                            {item.ItemName}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                            {item.TotalQuantity}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                            {item.NetAmount.toFixed(2)}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                            {item.TotalCGSTAmount.toFixed(2)}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                            {item.TotalSGSTAmount.toFixed(2)}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                            {item.TotalDiscountAmount}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                            {item.TotalAmount.toFixed(2)}
                          </TableCell>
                        </TableRow>
                      );

                      if (index === array.length - 1 || item.InvoiceDate !== array[index + 1].InvoiceDate) {
                        acc.push(
                          <TableRow key={`total-${item.InvoiceDate}`}>
                            <TableCell colSpan={8} sx={{ borderBottom: '1px solid #F5F5F5', backgroundColor: '#201658', color: 'white', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                              Total: {currentDayTotal.toFixed(2)}
                            </TableCell>
                          </TableRow>
                        );
                      }

                      return acc;
                    }, [])}
                  </TableBody>


                </Table>
              </TableContainer>
            ) : (
              <div style={{ marginTop: '20px', textAlign: 'center', color: 'red', fontWeight: 'bold' }}>
                No data found
              </div>
            )}
          </div>
        </div>
      </Modal>


    </div >
  );
}

export default CustomerIndex;
